import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "checkAll", "exportButton", "count", "infoSection"]

  initialize() {
    this.selectedIds = new Set()
  }

  connect() {
    this.syncCheckboxes()
    this.updateUI()
    
    // Optional: Zustand der Info-Sektion aus localStorage laden
    if (this.hasInfoSectionTarget) {
      const isVisible = localStorage.getItem("passdata_info_visible") === "true"
      this.infoSectionTarget.classList.toggle("d-none", !isVisible)
    }
  }

  // Schaltet die Sichtbarkeit der Stats & Security Bar um
  toggleInfo(e) {
    if (e) e.preventDefault()
    if (this.hasInfoSectionTarget) {
      const isHidden = this.infoSectionTarget.classList.contains("d-none")
      this.infoSectionTarget.classList.toggle("d-none")
      localStorage.setItem("passdata_info_visible", isHidden ? "true" : "false")
      
      // Optisches Feedback für den Button (Active state)
      e.currentTarget.classList.toggle("btn-header-active", isHidden)
    }
  }

  checkboxTargetConnected() {
    this.syncCheckboxes()
  }

  syncCheckboxes() {
    this.checkboxTargets.forEach(cb => {
      if (this.selectedIds.has(cb.value)) {
        cb.checked = true
      }
    })
    this.updateCheckAllState()
  }

  toggleAll(e) {
    const checked = e.target.checked
    this.checkboxTargets.forEach(cb => {
      cb.checked = checked
      this.updateIdStore(cb.value, checked)
    })
    this.updateUI()
  }

  toggleSingle(e) {
    const cb = e.target
    this.updateIdStore(cb.value, cb.checked)
    this.updateCheckAllState()
    this.updateUI()
  }

  updateIdStore(id, isSelected) {
    if (isSelected) {
      this.selectedIds.add(id)
    } else {
      this.selectedIds.delete(id)
    }
  }

  updateCheckAllState() {
    if (this.hasCheckAllTarget) {
      const allVisibleChecked = this.checkboxTargets.length > 0 && 
                               this.checkboxTargets.every(cb => cb.checked)
      this.checkAllTarget.checked = allVisibleChecked
    }
  }

  updateUI() {
    const totalSelected = this.selectedIds.size
    
    if (this.hasExportButtonTarget) {
      this.exportButtonTarget.disabled = totalSelected === 0
      if (totalSelected > 0) {
        this.exportButtonTarget.innerHTML = `<i class="bi bi-download me-1"></i> Export (${totalSelected})`
      } else {
        this.exportButtonTarget.innerHTML = `<i class="bi bi-download me-1"></i> Export`
      }
    }
  }

  submitExport(e) {
    if (this.selectedIds.size === 0) return

    const url = new URL(e.currentTarget.href, window.location.origin)
    this.selectedIds.forEach(id => {
      url.searchParams.append("ids[]", id)
    })

    e.currentTarget.href = url.toString()
  }
}
